//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data: function data() {
		return { tabs: [] };
	},
	created: function created() {
		this.tabs = this.$children;
	},
	mounted: function mounted() {
		var _this = this;

		Event.$on('reset-tabs', function () {
			_this.tabs.map(function (tab) {
				return tab.isActive = false;
			});
			_this.tabs[0].isActive = true;
		});

		// select the first tab to fire event
		this.selectTab(this.tabs[0]);

		Event.$on('manually-select-tab', function (tab) {
			return _this.selectTab(tab);
		});
	},


	methods: {
		selectTab: function selectTab(selectedTab) {

			this.tabs.forEach(function (tab) {

				tab.isActive = tab.name == selectedTab.name;
			});
			Event.$emit('tab-type', selectedTab.name);
			if (selectedTab.event) {
				Event.$emit(selectedTab.event);
			}
		}
	}

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/Tabs.vue
// module id = Lu2Z
// module chunks = 0 1